import { Input, Label } from "@egaranti/components";

import { useTranslation } from "react-i18next";

const CustomerInfo = ({ data }) => {
  const { t } = useTranslation();

  return (
    /*
      EPS-5120 (10. bulgu) — musteri detayinda telefon numarasinin sonu
      gorunmuyordu.

      Izgara her ekranda `grid-cols-2` idi. Replikada olculdu (390 px):
      sutunlar `141.5px x2`, telefon girdisinin genisligi 142 px ama icerigi
      147 px -> `scrollWidth > clientWidth`, numara kirpiliyor. Web 1440'ta
      sutun 330.5 px, kirpma yok.

      Cozum: dar ekranda tek sutun; sm'den itibaren eski iki sutun aynen.
    */
    <div className="formBox grid grid-cols-1 gap-4 sm:grid-cols-2">
      <h2 className="mb-5 text-lg font-medium sm:col-span-2">
        {t("clientsPage.customerInfo")}
      </h2>
      <div className="flex flex-col gap-4">
        <Label>{t("common.firstName")}</Label>
        <Input value={data?.firstName} disabled />
      </div>
      <div className="flex flex-col gap-4">
        <Label>{t("common.lastName")}</Label>
        <Input value={data?.lastName} disabled />
      </div>
      <div className="flex flex-col gap-4">
        <Label>{t("clientsPage.email")}</Label>
        <Input value={data?.email} disabled />
      </div>
      <div className="flex flex-col gap-4">
        <Label>{t("clientsPage.phone")}</Label>
        <Input value={data?.phone} disabled />
      </div>
    </div>
  );
};

export default CustomerInfo;
